import { PatchEntityStateDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiConnector } from './api-connector.abstract-service';

export abstract class ApiEntityStateConnector<TFull extends { _id: TId }, TSummary, TId> extends ApiConnector<
  TFull,
  TSummary,
  TId
> {
  activate(itemId: TId): Observable<TFull> {
    return this.apiCaller.patchRequest<TFull>(this.apiPrefix, `${this.slug}/${itemId}/activate`);
  }

  deactivate(itemId: TId, patchState?: PatchEntityStateDto): Observable<TFull> {
    return this.apiCaller.patchRequest<TFull>(
      this.apiPrefix,
      `${this.slug}/${itemId}/deactivate`,
      patchState,
    );
  }

  deleteState(itemId: TId, patchState?: PatchEntityStateDto): Observable<boolean> {
    return this.apiCaller.patchRequest<boolean>(this.apiPrefix, `${this.slug}/${itemId}/delete`, patchState);
  }
}
